import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

// Renders a linear barcode (e.g. Code 128) from the given value.
// Symbology is configurable so any external system's scanner format can be matched.
const Barcode = ({ value, format = "CODE128", height = 60, fontSize = 16 }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || value === undefined || value === null || value === "") {
      return;
    }
    try {
      JsBarcode(ref.current, String(value), {
        format,
        height,
        fontSize,
        displayValue: true,
        margin: 0,
      });
    } catch (e) {
      // Value isn't valid for the selected symbology — render nothing.
    }
  }, [value, format, height, fontSize]);

  if (value === undefined || value === null || value === "") return null;

  return <svg ref={ref} />;
};

export default Barcode;
